import React, { createContext, useState } from "react";

export const lapContext = createContext();

function OverLapContext({ children }) {
  const [isSuccess, SetIsSuccess] = useState(false);
  const [user, setUser] = useState([]);
  const [status, setStatus] = useState(false);
  const [loginStatus, setLogingStatus] = useState(false);
  const [isUserActive, setIsUserActive] = useState(false);

  return (
    <lapContext.Provider
      value={{
        isSuccess,
        SetIsSuccess,
        user,
        setUser,
        status,
        setStatus,
        loginStatus,
        setLogingStatus,
        isUserActive,
        setIsUserActive,
      }}
    >
      {children}
    </lapContext.Provider>
  );
}

export default OverLapContext;
